/* MOESTA Magazin-Suche mit Grill-Glossar (TL6-16, Claude Umsetzungs-Chat, 21.10.2026)
   Live-Vorschläge: Beiträge über /search/suggest.json, Begriffe aus assets/moesta-glossar-codex-data.js
   (nur lesen), geprüft über /search?view=glossar-index (nur veröffentlichte, indexierte Einträge). */
(function () {
  if (window.MOESTA_MMS_READY) return;
  window.MOESTA_MMS_READY = true;

  var TOPIC_TAGS = ['Rezept', 'Kaufberater', 'Feuerplatte', 'Pelletgrill', 'Zubehör & Alltag', 'MOESTA erleben'];
  var glossarPromise = null;
  var indexCache = {};

  function norm(value) {
    return String(value || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function loadGlossar(src) {
    if (window.MOESTA_GLOSSAR_PREVIEW) return Promise.resolve(window.MOESTA_GLOSSAR_PREVIEW);
    if (glossarPromise) return glossarPromise;
    glossarPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { resolve(window.MOESTA_GLOSSAR_PREVIEW || []); };
      s.onerror = function () { glossarPromise = null; resolve([]); };
      document.head.appendChild(s);
    });
    return glossarPromise;
  }

  function scoreTerm(item, query, words) {
    var title = norm(item.begriff);
    var names = [title].concat((item.aliase || []).map(norm));
    var hay = names.join(' ');
    if (!words.every(function (w) { return hay.indexOf(w) > -1; })) return 0;
    var starts = words.every(function (w) { return (' ' + hay).indexOf(' ' + w) > -1; });
    if (!starts && query.length < 5) return 0;
    if (!starts) return 20;
    if (title === query) return 100;
    if (names.indexOf(query) > -1) return 90;
    if (title.indexOf(query) === 0) return 80;
    if (names.some(function (n) { return n.indexOf(query) === 0; })) return 70;
    if ((' ' + title).indexOf(' ' + words[0]) > -1) return 60;
    return 40;
  }

  function glossarHits(cfg, raw, limit) {
    var query = norm(raw);
    var words = query.split(' ').filter(function (w) { return w.length > 1; });
    if (query.length < 2 || !words.length) return Promise.resolve([]);
    return loadGlossar(cfg.src).then(function (data) {
      function rank(q, ws) {
        return (data || []).map(function (item) {
          return { item: item, s: item && item.handle ? scoreTerm(item, q, ws) : 0 };
        }).filter(function (h) { return h.s > 0; });
      }
      var scored = rank(query, words);
      if (!scored.length && words.length > 1) {
        var seen = {};
        words.forEach(function (w) {
          if (w.length < 4) return;
          rank(w, [w]).forEach(function (h) {
            if (!seen[h.item.handle] || seen[h.item.handle].s < h.s) seen[h.item.handle] = h;
          });
        });
        scored = Object.keys(seen).map(function (k) { return seen[k]; });
      }
      var handles = scored.sort(function (a, b) {
        return b.s - a.s || a.item.begriff.length - b.item.begriff.length || a.item.begriff.localeCompare(b.item.begriff, 'de');
      }).slice(0, 10).map(function (h) { return h.item.handle; });
      if (!handles.length) return [];
      var missing = handles.filter(function (h) { return !(h in indexCache); });
      var ready = missing.length ? fetch(cfg.indexUrl + '?view=glossar-index&type=page&q=' + encodeURIComponent(missing.join(' ')), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (list) {
          missing.forEach(function (h) { indexCache[h] = null; });
          (list || []).forEach(function (e) { indexCache[e.handle] = e; });
        }) : Promise.resolve();
      return ready.then(function () {
        return handles.map(function (h) { return indexCache[h]; }).filter(Boolean).slice(0, limit);
      });
    }).catch(function () { return []; });
  }

  function fetchArticles(cfg, q, signal) {
    var url = cfg.suggestUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=article&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,body,tag';
    return fetch(url, { credentials: 'same-origin', signal: signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.articles) || [];
        return list.filter(function (a) { return a && a.url && a.url.indexOf('/blogs/news/') > -1; });
      });
  }

  function articlesMerged(cfg, q, signal) {
    var phrase = q.trim();
    var words = phrase.split(/\s+/).filter(function (w) { return w.length > 2; }).slice(0, 3);
    if (words.length < 2) {
      return fetchArticles(cfg, phrase, signal).then(function (list) {
        list.forEach(function (a) { a._mark = phrase; });
        return list;
      });
    }
    var queries = [phrase].concat(words);
    return Promise.all(queries.map(function (x) { return fetchArticles(cfg, x, signal); })).then(function (sets) {
      var byUrl = {}, order = [];
      sets.forEach(function (list) {
        list.forEach(function (a, i) {
          var k = a.url.split('?')[0];
          if (!byUrl[k]) { byUrl[k] = { a: a, sets: 0, pos: order.length }; order.push(k); }
          byUrl[k].sets += 1 + (i === 0 ? 3 : (i < 3 ? 1 : 0));
        });
      });
      return order.map(function (u) {
        var e = byUrl[u], t = norm(e.a.title), hits = 0, mark = '';
        words.forEach(function (w) {
          if (t.indexOf(norm(w)) > -1) { hits += 1; if (!mark || w.length > mark.length) mark = w; }
        });
        e.a._mark = mark;
        e.score = hits * 3 + e.sets;
        return e;
      }).sort(function (x, y) { return y.score - x.score || x.pos - y.pos; }).map(function (e) { return e.a; });
    });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function appendMarked(node, text, mark) {
    var i = mark ? text.toLowerCase().indexOf(mark.toLowerCase()) : -1;
    if (i < 0) { node.appendChild(document.createTextNode(text)); return; }
    node.appendChild(document.createTextNode(text.slice(0, i)));
    node.appendChild(el('mark', null, text.slice(i, i + mark.length)));
    node.appendChild(document.createTextNode(text.slice(i + mark.length)));
  }

  function topicOf(a) {
    var tags = a.tags || [];
    for (var i = 0; i < TOPIC_TAGS.length; i++) if (tags.indexOf(TOPIC_TAGS[i]) > -1) return TOPIC_TAGS[i];
    return 'Magazin';
  }

  function imgOf(a) {
    var u = (a.featured_image && a.featured_image.url) || a.image || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=220';
  }

  function resultsUrl(cfg, q) {
    return cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&type=article&options%5Bprefix%5D=last';
  }

  function initBox(root) {
    var input = root.querySelector('[data-mms-input]');
    var panel = root.querySelector('[data-mms-panel]');
    var clear = root.querySelector('[data-mms-clear]');
    var form = root.querySelector('form');
    if (!input || !panel || !window.fetch) return;
    var cfg = {
      src: root.dataset.glossarSrc,
      indexUrl: root.dataset.indexUrl,
      suggestUrl: root.dataset.suggestUrl,
      searchUrl: root.dataset.searchUrl || '/search'
    };
    var timer = null, ctrl = null, seq = 0, options = [], active = -1;
    var uid = input.id;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function setActive(i) {
      options.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
      active = i;
      if (i < 0 || !options[i]) { input.removeAttribute('aria-activedescendant'); return; }
      options[i].classList.add('is-active');
      options[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', options[i].id);
      if (options[i].scrollIntoView) options[i].scrollIntoView({ block: 'nearest' });
    }
    function opt(node) {
      node.id = uid + '-opt-' + options.length;
      node.setAttribute('role', 'option');
      node.setAttribute('aria-selected', 'false');
      node.tabIndex = -1;
      options.push(node);
      return node;
    }

    function render(q, terms, arts) {
      options = [];
      active = -1;
      panel.textContent = '';
      if (!terms.length && !arts.length) {
        var empty = el('div', 'mms__empty');
        empty.appendChild(el('p', 'mms__empty-title', 'Nichts gefunden zu „' + q + '“.'));
        empty.appendChild(el('p', 'mms__empty-text', 'Prüf die Schreibweise oder versuch es mit einem dieser Themen:'));
        var chips = el('div', 'mms__chips');
        ['Kerntemperatur', 'Einbrennen', 'Ente', 'Winter'].forEach(function (w) {
          var b = el('button', 'mms__chip', w);
          b.type = 'button';
          b.addEventListener('click', function () { input.value = w; run(true); input.focus(); });
          chips.appendChild(b);
        });
        empty.appendChild(chips);
        panel.appendChild(empty);
        open();
        return;
      }
      var grid = el('div', 'mms__grid' + (terms.length ? '' : ' mms__grid--single'));
      if (terms.length) {
        var col = el('div', 'mms__terms');
        col.setAttribute('role', 'group');
        col.setAttribute('aria-label', 'Begriff erklärt');
        col.appendChild(el('p', 'mms__kicker', 'Begriff erklärt'));
        var top = opt(el('a', 'mms__term-top'));
        top.href = terms[0].url;
        top.appendChild(el('span', 'mms__badge', 'Grill-Glossar'));
        top.appendChild(el('span', 'mms__term-title', terms[0].begriff));
        if (terms[0].text) top.appendChild(el('span', 'mms__term-text', terms[0].text));
        top.appendChild(el('span', 'mms__term-more', 'Im Glossar lesen →'));
        col.appendChild(top);
        if (terms.length > 1) {
          var more = el('div', 'mms__term-list');
          terms.slice(1).forEach(function (t) {
            var a = opt(el('a', 'mms__term'));
            a.href = t.url;
            a.appendChild(el('span', null, t.begriff));
            var arrow = el('span', null, '→');
            arrow.setAttribute('aria-hidden', 'true');
            a.appendChild(arrow);
            more.appendChild(a);
          });
          col.appendChild(more);
        }
        grid.appendChild(col);
      }
      var colA = el('div', 'mms__articles');
      colA.setAttribute('role', 'group');
      colA.setAttribute('aria-label', 'Beiträge');
      colA.appendChild(el('p', 'mms__kicker', 'Beiträge'));
      if (!arts.length) colA.appendChild(el('p', 'mms__none', 'Kein Beitrag zu „' + q + '“. Schau dir den Begriff im Glossar an.'));
      arts.forEach(function (a) {
        var row = opt(el('a', 'mms__article'));
        row.href = a.url;
        var src = imgOf(a);
        if (src) {
          var img = el('img');
          img.src = src;
          img.alt = '';
          img.width = 104;
          img.height = 70;
          img.loading = 'lazy';
          row.appendChild(img);
        } else {
          row.appendChild(el('span', 'mms__noimg'));
        }
        var txt = el('span', 'mms__article-text');
        txt.appendChild(el('span', 'mms__tag', topicOf(a)));
        var title = el('span', 'mms__article-title');
        appendMarked(title, a.title || '', a._mark || q);
        txt.appendChild(title);
        row.appendChild(txt);
        colA.appendChild(row);
      });
      grid.appendChild(colA);
      panel.appendChild(grid);
      var all = opt(el('a', 'mms__all', 'Alle Treffer für „' + q + '“ anzeigen →'));
      all.href = resultsUrl(cfg, q);
      panel.appendChild(all);
      open();
    }

    function run(now) {
      var q = input.value.trim();
      if (clear) clear.hidden = !input.value;
      clearTimeout(timer);
      if (q.length < 2) { if (ctrl) ctrl.abort(); close(); panel.textContent = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var my = ++seq;
        Promise.all([
          glossarHits(cfg, q, 4),
          articlesMerged(cfg, q, ctrl ? ctrl.signal : undefined).catch(function (e) {
            if (e && e.name === 'AbortError') throw e;
            return [];
          })
        ]).then(function (res) {
          if (my !== seq) return;
          render(q, res[0], res[1].slice(0, 5));
        }).catch(function () {});
      }, now ? 0 : 180);
    }

    input.addEventListener('focus', function () {
      loadGlossar(cfg.src);
      if (input.value.trim().length >= 2 && panel.childNodes.length) open();
    }, { once: false });
    input.addEventListener('input', function () { run(false); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (panel.hidden || !options.length) return;
        e.preventDefault();
        var n = options.length;
        setActive(e.key === 'ArrowDown' ? (active + 1) % n : (active <= 0 ? n - 1 : active - 1));
      } else if (e.key === 'Enter') {
        if (!panel.hidden && active > -1 && options[active]) {
          e.preventDefault();
          window.location.href = options[active].href;
        }
      } else if (e.key === 'Escape') {
        if (!panel.hidden) { e.preventDefault(); close(); }
      }
    });
    if (clear) clear.addEventListener('click', function () {
      input.value = '';
      run(true);
      input.focus();
    });
    root.querySelectorAll('[data-mms-pick]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = b.getAttribute('data-mms-pick');
        input.focus();
        run(true);
      });
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
    if (clear) clear.hidden = !input.value;
  }

  function initCard(box) {
    var cfg = { src: box.dataset.glossarSrc, indexUrl: box.dataset.indexUrl };
    glossarHits(cfg, box.dataset.terms || '', 6).then(function (hits) {
      if (!hits.length) return;
      var t = hits[0];
      box.querySelector('[data-mms-card-title]').textContent = t.begriff;
      box.querySelector('[data-mms-card-text]').textContent = t.text || '';
      box.querySelector('[data-mms-card-link]').href = t.url;
      var rel = box.querySelector('[data-mms-card-related]');
      var relWrap = box.querySelector('[data-mms-card-related-wrap]');
      if (hits.length > 1) {
        hits.slice(1).forEach(function (h) {
          var a = el('a', 'mms-card__chip', h.begriff);
          a.href = h.url;
          rel.appendChild(a);
        });
      } else if (relWrap) {
        relWrap.hidden = true;
        box.classList.add('mms-card--single');
      }
      box.hidden = false;
      var count = document.querySelector('[data-mms-glossar-count]');
      if (count) {
        count.textContent = (hits.length === 1 ? '1 Begriff' : hits.length + ' Begriffe') + ' im Glossar, ';
        count.hidden = false;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-mms]').forEach(initBox);
    document.querySelectorAll('[data-mms-card]').forEach(initCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
